import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-labelledby=\"locationIconTitle\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"miter\" fill=\"none\" id=\"icon-location\"> <title id=\"icon-location_locationIconTitle\">Location</title> <path d=\"M12,21 C16,16.8 18,12.8 18,9 C18,5.6862915 15.3137085,3 12,3 C8.6862915,3 6,5.6862915 6,9 C6,12.8 8,16.8 12,21 Z\" /> <circle cx=\"12\" cy=\"9\" r=\"1\" /> </symbol>"
});
var result = sprite.add(symbol);
export default symbol